import { motion } from 'framer-motion';
import './MirrorChipActivation.css';

const formatRoll = (roll) => String(roll ?? 0);

const MirrorChipActivation = ({
  before,
  after,
  reduceMotion = false,
}) => (
  <motion.div
    className="coreboundMirrorActivation"
    role="status"
    aria-live="polite"
    initial={reduceMotion ? false : { opacity: 0, scale: 0.72, rotateX: -24 }}
    animate={
      reduceMotion
        ? { opacity: 1 }
        : { opacity: [0, 1, 1], scale: [0.72, 1.08, 1], rotateX: [24, -8, 0] }
    }
    transition={{ duration: 0.72, ease: 'easeOut' }}
  >
    <span className="coreboundMirrorActivationKicker">RELIC ACTIVATED</span>
    <strong className="coreboundMirrorActivationTitle">Mirror Chip</strong>
    <div
      className="coreboundMirrorActivationValues"
      aria-label={`${formatRoll(before)} reversed to ${formatRoll(after)}`}
    >
      <span>{formatRoll(before)}</span>
      <b aria-hidden="true">↻</b>
      <strong>{formatRoll(after)}</strong>
    </div>
    <small>Single digits are zero-padded before reversing</small>
  </motion.div>
);

export default MirrorChipActivation;
